<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <div class="pageHeader row align-items-center">
        <div class="col-3 pageHeaderTitle">SAML Group Mapping</div>
        <div class="col text-right">
          <div class="filterWrapper">
            <div class="filterText">Tenant :</div>
            <div class="dropdown col p-0">
              <model-select v-model="lastSelectedTenantObj" :options="tenants" name="tenantLableName" id="tenantLableId"
                placeholder="Select Tenant" @input="validateSelection" class="tenantsList">
              </model-select>
              <!-- <Dropdown
                style="background: transparent; color: #fff; border: 0"
                v-model="lastSelectedTenant"
                v-on:filter="getDropdownValues"
                :options="tenantsList"
                v-on:selected="validateSelection"
                :disabled="false"
                :maxItem="tenantsList.length"
                name="tenantDropdown"
                class="tenantsList"
                placeholder="Please select a tenant"
              >
              </Dropdown> -->
              <!-- <select style="background: transparent; color: #fff;  border: 0;" v-model="lastSelectedTenant"
                  @change="getGroups();">
                  <option class="tenantOption" v-for="option in tenants" v-bind:key="option.value"
                      :value="option.value">{{ option.text ? option.text : option.value }}
                  </option>
              </select> -->
            </div>
          </div>
          <div class="filterWrapper filter-wrapper-2">
            <div class="filterText">Filter:</div>
            <input v-model="filterString" type="text" maxlength="20" class="filterInputText" />
          </div>
          <div class="importBtn" @click="addModal()" v-b-modal.modal-1>Add</div>
        </div>
      </div>

      <div class="pageDataWrapper">
        <div class="contentHeader row m-0 align-items-center">
          <div class="col-4">Name</div>
          <div class="col-4">Description</div>
          <div class="col">Roles</div>
          <div class="col-2 actionHeading text-center">Action</div>
        </div>
        <div>
          <h3 style="margin:20px;color:#1a8088" className="table-data-info" v-if="listEmpty">
            No Results Found
          </h3>
        </div>
        <div class="pageData">
          <div v-for="samlGroup in groups.filter(function (u) {
              if (!filterString || filterString.trim().length === 0) {
                return true;
              }
              return (
                (u.name &&
                  u.name.toLowerCase().indexOf(filterString.toLowerCase()) >=
                  0));
                  }) " v-bind:key="samlGroup.name"
            class="contentHeader row m-0 align-items-center mt-2 p-2">
            <div class="col-4">{{ samlGroup.name }}</div>
            <div class="col-4">{{ samlGroup.description }}</div>
            <div class="col">
              {{ samlGroup.roles ? samlGroup.roles.join(", ") : "" }}
            </div>
            <div class="col-2 actionHeading text-center">
              <img v-on:click="
                lastSelectedTenant !== '*' ? onEditChanged(samlGroup) : false
                " onclick="false" src="../assets/images/edit.svg" width="16" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="modalShow" hide-backdrop id="modal-1">
      <!-- <b-container> -->
        <div>
          <TreeView :selectedSamlGroup="selectedSAMLGroup" :lastSelectedTenant="lastSelectedTenant"
            @closeEvent="closeModal()" />
        </div>
      <!-- </b-container> -->
    </b-modal>
  </section>
</template>
<script>
import Vue from "vue";
import TreeView from "../components/TreeView.vue";
import Dropdown from "vue-simple-search-dropdown";
import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
export default {
  components: {
    TreeView,
    Dropdown,
    ModelSelect
  },
  data() {
    return {
      tenants: [{ text: "-SELECT ALL-", value: "*" }],
      roles: [],
      tenantsList: [],
      lastSelectedTenant: "",
      lastSelectedTenantObj: "",
      selectedGroupId: "",
      filterString: "",
      modalShow: false,
      name: "",
      description: "",
      editRoleName: "",
      editRoleDescription: "",
      groups: [],
      groupId: "",
      tenantId: "",
      locations: [],
      selectedSAMLGroup: null,
      listEmpty:false
    };
  },
  mounted() {
    this.fetchTenants();
    $("input").attr("autocomplete", "off");
  },
  methods: {
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.getGroups();
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id
      }
      else {
        return ""
      }
    },
    getDropdownValues(tenant) {
      return this.tenantsList.filter((e) => e.id == tenant || e.name == tenant);
    },
    async fetchTenants() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status === 503) {
          return this.fetchTenants();
        }
        var response = await tenants_list.json();
        this.tenants = response
          .map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace('-', ''),
            };
          })
          .sort((a, b) => {
            return a.text.localeCompare(b.text);
          });
        this.tenants.forEach((e) =>
          this.tenantsList.push({ id: e.value, name: e.text || e.value })
        );
      } catch (error) {
        console.error(error);
      }
    },
    addModal() {
      this.selectedSAMLGroup = {};
      this.showModal();
    },
    closeModal() {
      this.getGroups();
      this.selectedSAMLGroup = {};
      this.modalShow = false;
    },
    showModal() {
      this.modalShow = true;
    },
    async onEditChanged(samlGroup) {
      this.selectedSAMLGroup = samlGroup;
      this.showModal();
    },
    json2array(json) {
      var result = [];
      var keys = Object.keys(json);
      keys.forEach(function (key) {
        var arrObj = {};
        arrObj["name"] = key;
        for (var keyEle in json[key]) {
          arrObj[keyEle] = json[key][keyEle];
        }
        result.push(arrObj);
      });
      return result;
    },
    async fetchRoles() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.IDENTITY_MANGER + `/tenants/${this.lastSelectedTenant}/roles`;
      var fetch_Roles = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(fetch_Roles);
        if (response.status === 503) {
          return this.fetchRoles();
        }
        var roles_fetch = await response.json();
        var roles = this.json2array(roles_fetch);
        this.roles = roles;
      } catch (err) {
        console.error(err);
      }
    },
    async getGroups() {
      let loader=Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.listEmpty=false;
      this.groups=[];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/saml-groups`;
      var saml_Groups = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(saml_Groups);
        if (response.status === 503) {
          return this.getGroups();
        }
        var groups_saml = await response.json();
        this.groups = groups_saml.items;
        if (this.groups.length == 0) {
              loader.hide();
              this.listEmpty = true;
            } else if (this.groups.length > 0) {
              loader.hide();
              this.listEmpty = false;
            }
          
      } catch (error) {
        console.error(error);
      }
    },
    getGrpId($event, roles) {
      this.selectedGroupId = roles._id;
    },
    async getGroupId() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/saml-groups/${this.selectedGroupId}`;
      var saml_Groups = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(saml_Groups);
        if (response.status === 503) {
          return this.getGroupId();
        }
        var groups_saml = await response.json();
        this.groupId = groups_saml;
      } catch (error) {
        console.error(error);
      }
    },
    async getLocation() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/location/userLocations?tenantName=${this.lastSelectedTenant}`;
      var get_Location = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.getLocation();
        }
        var getLoc = await response.json();
        this.locations = getLoc;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style lang="scss">
.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

 .ui.selection.dropdown {
   border: none !important;

   i.dropdown.icon {
     display: none;
   }
 }

 .pageHeader {
   font-size: 20px;
 }

 .pageHeaderTitle {
   padding-left: 15px !important;
 }

 .filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 15px;
  min-width: 360px;
  max-width: 360px;
  border-radius: 5px;
  margin-left: 10px;
  align-items: center;
  text-overflow: ellipsis;
}
.pageHeader .filterWrapper .dropdown:before {
  border: solid #fff;
  border-width: 0 1px 1px 0;
}


.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}

.filter-wrapper-2 {
  max-width: 400px;
  min-height: 36px;
}

 .filterText {
   color: #fff;
   opacity: 1;
   padding-right: 5px;
 }

 .filterWrapper .dropdown {
   width: 100%;
   text-align: left;
   cursor: pointer;
   background: transparent !important;
   height: auto;
 }

 .filterInputText {
   max-width: 215px !important;
   background: #575757 !important;
   outline: none !important;
   border: 1px solid #575757 !important;
   color: #fff !important;
   padding: 1px 15px;
 }

 .pageHeader .importBtn{
  background: #575757;
}
.pageHeader .importBtn:hover{
  background: #1dd8f6;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
  width: auto;
  line-height: 36px;
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background:#3288D2;
}

.contentHeader {
  background: #ebebeb;
  height: 42px;
  color: #484848;
  border-radius: 5px;
}
.pageData .contentHeader{
  height:auto;
  background:#fff;
  border:1px solid #ebebeb;
  color:#6a6a6a;
}
.pageData .contentHeader:hover{
  background:#f2fdff;
  cursor:pointer;
}

 .contentHeader>div.actionHeading {
   justify-content: center !important;
 }

 .pageDataWrapper {
  padding: 15px;
  }


 .requestCol-saml {
   background-color: white;
   padding: 15px;
   display: flex;
   flex-direction: column;
 }

 .requestCol-saml textarea,
 .requestCol-saml textarea:focus {
   border: 1px solid #ebebeb;
   box-shadow: none;
   max-width: 100%;
   color:#6a6a6a;
 }

 .requestCol-saml select,
 .requestCol-saml select:focus {
   border: 1px solid black;
   background-color: #eee;
   max-width: 35rem;
 }

 #access-search {
   border: 1px solid black;
   border-bottom: 0;
   box-shadow: none;
 }

 .requestCol-saml select {
   max-width: 35rem;
 }

 #modal-1 .requestCol-saml,
 #modal-1 .previewCol {
   border-radius: 5px;
   min-height: 50vh;
   border: 1px solid #ebebeb;
 }

 #modal-1 .modal-body{
  padding:0px
 }

 #modal-1 .requestCol-saml h6{
  color:#3288D2;
 }

 .tenantOption {
   color: #6a6a6a;
   padding: 10px;
 }

 #collapsible-list {
   border: 1px solid black;
   height: 400px;
   width: 100%;
   display: flex;
   flex-direction: column;
   justify-content: flex-start;
 }

 #collapsible-list p {
   margin: 0;
 }

 .collapsible-item {
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }

 .ci-icon-container {
   display: flex;
   align-items: center;
 }

 .ci-icon {
   font-size: 2rem;
   background-color: white;
   color: white;
 }

 .ci-checkboxes {
   display: flex;
 }

 .ci-checkbox {
   display: flex;
   justify-content: space-between;
   align-items: center;
 }

 .ci-checkbox p {
   margin: 0 0.5rem !important;
 }

 .collapsible-stuff {
   width: 90%;
   float: right;
 }

 #collapsible-stuff1 {
   margin-left: 2rem;
 }

 .collapsible-item-container ul {
   margin: 0;
 }

 #access-container .col {
   margin: 0 !important;
   padding: 0 !important;
 }

 .facilitiesWrapper {
   max-height: 275px;
   min-height: 275px;
   overflow: hidden;
    border-bottom: 1px solid #ebebeb;
 }

 .facilityDetails {
   display: flex;
 }

 .headerpart {
   color: #484848;
   overflow: hidden;
   height: 40px;
   line-height: 40px;
   border-bottom: 1px solid #dae1f2;
   padding: 0 0;
   display: flex;
 }

 .facilitiesList {
   padding-top: 5px;
   overflow: hidden;
   padding-bottom: 5px;
   cursor: pointer;
   display: flex;
 }

 .facilitiesList {
   height: 36px;
   align-items: center;
 }

 .facilityListWrap.facilityListWrapLeft {
   max-height: 334px;
 }

 .facilityListWrap {
   max-height: 325px;
   overflow: hidden;
   overflow-y: auto;
 }

 .pull-left {
   float: left;
 }

 .treeWrapper.facilityTreeWrapper {
   max-height: 364px;
 }

 .treeWrapper,
 .facilityListWrap {
   max-height: 235px;
   overflow: hidden;
   overflow-y: auto;
 }

 .treeWrapper {
   margin: 5px 0 5px 20px;
 }
 .facilityListName{
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
 }
</style>
<style lang="scss" scoped>
::v-deep .ui.search.dropdown .text {
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #fff;
  height: 15px;
}

::v-deep .ui.selection.dropdown .menu .item{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // max-width: 334px;
    margin: 0px 10px 2px;
    padding: 10px 7px !important;
    border-radius: 5px;
    border: none;
}
.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}

::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}
::v-deep #modal-1 .modal-dialog {
  max-width:850px;
}
::v-deep .multiselect__tag{
  background: #1dd8f6;
}
::v-deep .multiselect__tag-icon:focus, ::v-deep .multiselect__tag-icon:hover{
  background: #3288D2;
}
</style>
